import { getRequest } from '@/core';
import { transporterOrders } from '@/requests';

export default async function getTransporterOrdersRequest(filter) {
	let url = transporterOrders.getPath();
	let response = await getRequest(url, filter);
	return response;
}
